import {z} from 'zod'

export const exerciseTypes = [
  {
    type: 'single_choice',
    label: 'Single choice',
    icon: 'check-circle',
    schema: z.object({
      question: z.string().min(1),
      options: z
        .array(z.object({label: z.string(), isCorrect: z.boolean()}))
        .min(2)
        .max(6),
      explanation: z.string().optional(),
    }),
  },
  {
    type: 'multiple_choice',
    label: 'Multiple choice',
    icon: 'check-square',
    schema: z.object({
      question: z.string().min(1),
      options: z
        .array(z.object({label: z.string(), isCorrect: z.boolean()}))
        .min(2)
        .max(6),
      explanation: z.string().optional(),
    }),
  },
  {
    type: 'true_false',
    label: 'True / False',
    icon: 'toggle-right',
    schema: z.object({
      question: z.string().min(1),
      answer: z.union([z.boolean(), z.literal('true'), z.literal('false')]),
      explanation: z.string().optional(),
    }),
  },
  {
    type: 'fill_blank',
    label: 'Fill in the blank',
    icon: 'edit-3',
    schema: z.object({
      question: z.string().min(1),
      blanks: z
        .array(
          z.object({
            id: z.string(),
            before: z.string(),
            answer: z.string().min(1),
            after: z.string(),
            alternatives: z.array(z.string()).optional(),
          }),
        )
        .min(1),
      explanation: z.string().optional(),
    }),
  },
  {
    type: 'matching',
    label: 'Matching pairs',
    icon: 'shuffle',
    schema: z.object({
      question: z.string().min(1),
      pairs: z
        .array(
          z.object({
            id: z.string(),
            left: z.string().min(1),
            right: z.string().min(1),
          }),
        )
        .min(2),
      explanation: z.string().optional(),
    }),
  },
  {
    type: 'ordering',
    label: 'Ordering',
    icon: 'list',
    schema: z.object({
      question: z.string().min(1),
      orderItems: z
        .array(z.object({id: z.string(), label: z.string().min(1)}))
        .min(2),
      correctOrder: z.array(z.string()),
      explanation: z.string().optional(),
    }),
  },
  {
    type: 'image_choice',
    label: 'Image choice',
    icon: 'image',
    schema: z.object({
      question: z.string().min(1),
      options: z
        .array(
          z.object({
            label: z.string(),
            imageUrl: z.string().optional(),
            isCorrect: z.boolean(),
          }),
        )
        .min(2)
        .max(6),
      explanation: z.string().optional(),
    }),
  },
]
